import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  primary: "bg-purple text-cream hover:bg-purple-dark",
  turquoise: "bg-turquoise text-charcoal hover:brightness-95",
  marigold: "bg-marigold text-cream hover:brightness-95",
  sunny: "bg-sunny text-charcoal hover:brightness-95",
  outline: "bg-transparent border-2 border-purple text-purple hover:bg-purple hover:text-cream",
  cream: "bg-cream text-purple hover:bg-white",
};

// Editorial CTA with a nudging arrow. Renders a react-router Link (to),
// an anchor (href) or a button (onClick).
export default function ArrowLink({
  children,
  to,
  href,
  onClick,
  type,
  variant = "primary",
  arrow = true,
  className = "",
  testid,
  disabled = false,
}) {
  const classes = cn(
    "group inline-flex items-center justify-center gap-2 rounded-xl px-7 py-4 font-semibold text-base transition-[background-color,color,filter,transform] duration-300",
    VARIANTS[variant],
    disabled && "opacity-50 pointer-events-none",
    className
  );
  const inner = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
      )}
    </>
  );
  if (to) return <Link to={to} className={classes} data-testid={testid}>{inner}</Link>;
  if (href) return <a href={href} className={classes} data-testid={testid}>{inner}</a>;
  return (
    <button type={type || "button"} onClick={onClick} className={classes} data-testid={testid} disabled={disabled}>
      {inner}
    </button>
  );
}
